///<reference path='./okta-signin-widget.d.ts'/>

import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnInit } from '@angular/core';

import { AuthenticationState } from './authentication-state';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { Settings, Link } from '../core';

@Component({
    selector: 'okta-widget',
    template: require('./okta-widget.component.html'),
    styles: [require('./okta-widget.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OktaWidgetComponent implements OnInit {
    public shouldUseLegacyOktaWidget = false;

    public isLoading: boolean;

    public errorMessage = '';

    public forgotPasswordLink: Link;

    public idpLink: Link;

    @Input()
    public username: string;

    @Input()
    public password: string;

    public contactUsLink: Link;

    //private widget: any;

    constructor(
        private authenticationState: AuthenticationState,
        private urlBuilder: UrlBuilder,
        private settings: Settings,
        private changeDetector: ChangeDetectorRef
    ) {
        //this.forgotPasswordLink = this.settings.linksDictionary['forgot-password'];
        this.shouldUseLegacyOktaWidget = this.settings.shouldUseLegacyOktaWidget;
        //const returnUrl = encodeURI(window.location.href);

        //let idpLinks: CustomLink[] = [];

        //this.settings.idpLinks.forEach(idpLink => {
        //    let customLink: CustomLink = {
        //        text: idpLink.text,
        //        href: idpLink.url + returnUrl
        //    };
        //    idpLinks.push(customLink);
        //});

        //// build contact us url
        //settings.getSubDomain()
        //    .pipe(
        //        map(appSubDomain => appSubDomain === 'xsp' ? settings.linksDictionary['contact-us-sponsor'] : settings.linksDictionary['contact-us']),
        //    ).subscribe(contactUsLink => this.contactUsLink = contactUsLink);

        //const config: WidgetConfiguration = {
        //    authClient: this.authenticationState.oktaAuth,
        //    el: '#okta-signin-container',
        //    baseUrl: this.authenticationState.issuer.split('/oauth2')[0],
        //    logo: this.settings.oktaWidgetLogoPath,
        //    i18n: {
        //        en: {
        //            'primaryauth.title': this.settings.oktaWidgetTitle,
        //            'forgotpassword': this.settings.linksDictionary['forgot-password'].text,
        //            'needhelp': 'Password Manager and Additional Options',
        //            'help': this.contactUsLink.text
        //        },
        //    },
        //    clientId: this.authenticationState.clientId,
        //    redirectUri: this.authenticationState.redirectUrl,
        //    features: {
        //        idpDiscovery: this.settings.oktaWidgetIdpDiscovery
        //    },
        //    idpDiscovery: {
        //        requestContext: returnUrl,
        //    },
        //    helpLinks: {
        //        forgotPassword: this.settings.linksDictionary['forgot-password'].url,
        //        help: this.contactUsLink.url,
        //        custom: idpLinks
        //    }
        //};

        //this.widget = new OktaSignIn(config);
    }

    public ngOnInit() {
        //this.widgetLogin();
        this.authenticationState.login();
    }

    //public async widgetLogin() {

    //    try {
    //        let token = await this.widget.showSignInToGetTokens();

    //        this.authenticationState.oktaAuth.tokenManager.setTokens(token);

    //        await this.authenticationState.loginWithWidget();
    //        this.urlBuilder.esa().navigateToReturnUrl();
    //    } catch (e) {
    //        this.isLoading = false;
    //        console.warn('Error occurred during login', e);
    //        this.errorMessage = e && (e.message || e.error || e);
    //    } finally {
    //        this.changeDetector.markForCheck();
    //    }
    //}

    public hasError() {
        return !!this.errorMessage;
    }

    public isValid() {
        return this.username && this.password;
    }

    // this is the current login button functionality. redirects to custom okta domain page
    public async onSubmit() {
        this.isLoading = true;
        this.errorMessage = '';
        try {
            await this.authenticationState.login();
            this.urlBuilder.esa().navigateToReturnUrl();
        } catch (e) {
            this.isLoading = false;
            console.warn('Error occurred during login', e);
            this.errorMessage = e && (e.message || e.error || e);
        } finally {
            this.changeDetector.markForCheck();
        }
    }
}